import DashboardService from '@/services/DashboardService';
const state = {
  summary: {
    workInProgress: 0,
    readyForDelivery: 0,
    openJobCard: 0,
    completed: 0,
    carCollected: 0,
    qc: 0,
    washing: 0,
    fullPartIssue: 0,
    totalJobCards: 0,
    quotationApproval: 0,
    cancelled: 0,
    partialPartIssue: 0,
    roadTest: 0,
  },
};

const getters = {
  getJobcardSummary: (state) => state.summary,
};

const actions = {
  async fetchJobcardSummary({ commit }) {
    try {
      const response = await DashboardService.getDashboardJobcard();
      commit('setJobcardSummary', response.data);
    } catch (error) {
      // Error logging (just like using Logger in Java)
    }
  },

  updateJobcardSummary({ commit }, updatedData) {
    commit('setJobcardSummary', updatedData);
  },
};

const mutations = {
  setJobcardSummary(state, data) {
    state.summary = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
